import { Modal } from '@/components/common/Modal'
import { Button } from '@/components/common/Button'

interface PostUploadDialogProps {
  isOpen: boolean
  fileCount: number
  onExtract: () => void
  onContinue: () => void
}

export function PostUploadDialog({ isOpen, fileCount, onExtract, onContinue }: PostUploadDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onContinue} title="Datei hochgeladen" size="sm">
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          {fileCount === 1
            ? 'Möchtest du die Datei jetzt extrahieren oder weitere Dateien hochladen?'
            : `Möchtest du die ${fileCount} Dateien jetzt extrahieren oder weitere hochladen?`}
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onContinue}>
            Weiter hochladen
          </Button>
          <Button onClick={onExtract}>
            Jetzt extrahieren
          </Button>
        </div>
      </div>
    </Modal>
  )
}
